module.exports = __webpack_public_path__ + "static/media/carousal_2_desktop.e189e9c5.jpg";